export default __webpack_public_path__ + "images/AMEX.bf0d84d233fd32dc1b46eea1a8303987.svg";